<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <app-uzemszunet-sav forras="nav"></app-uzemszunet-sav>
  <div class="naplo-eszkozsor">
    <ion-button style="--background:var(--naplo)" (click)="navSzinkron()"><ion-icon slot="start" name="receipt"></ion-icon> NAV Számlázó szinkron</ion-button>
    <ion-button fill="outline" color="medium" (click)="navPartnerKinyer()"><ion-icon slot="start" name="people"></ion-icon> Partnerek kinyerése</ion-button>
    <ion-searchbar style="flex:1; min-width:200px" placeholder="Számlaszám / partner" [(ngModel)]="szuro"></ion-searchbar>
  </div>

  <div *ngIf="!navSzamlak.length" class="ures">
    <ion-icon name="receipt-outline"></ion-icon>
    Még nincs letöltött NAV-számla. Nyomd meg a <b>NAV Számlázó szinkron</b> gombot.
    A belépés a Tárhely fülön felvett fiók adataival történik.
  </div>

  <!-- NAV Online Számlázó számlái -->
  <div *ngIf="navSzamlak.length">
    <div class="naplo-eszkozsor" style="font-weight:600; color:var(--naplo); padding-bottom:0">
      <span><ion-icon name="receipt"></ion-icon> NAV Online Számlázó számlák ({{ szurtSzamlak.length }})</span>
    </div>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th></th><th>Számlaszám</th><th>Partner</th><th>Adószám</th><th>Cím</th><th>Dátum</th><th class="num">Nettó</th><th class="num">ÁFA</th><th class="num">Bruttó</th><th>Fiz.mód</th><th>PDF</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let s of szurtSzamlak" [style.background]="s.konyvelt ? '#dcfce7' : null">
            <td><ion-icon *ngIf="s.konyvelt" name="checkmark-circle" style="color:#15803d" title="Lekönyvelve"></ion-icon></td>
            <td>{{ s.szamlaszam }}</td><td>{{ s.partner }}</td>
            <td>{{ s.partner_adoszam }}</td>
            <td class="halvany" style="font-size:.82rem">{{ cim(s) }}</td>
            <td>{{ s.datum }}</td>
            <td class="num">{{ s.netto | number:'1.0-0' }}</td><td class="num">{{ s.afa | number:'1.0-0' }}</td>
            <td class="num">{{ s.brutto | number:'1.0-0' }}<span *ngIf="s.deviza && s.deviza !== 'HUF'"> {{ s.deviza }}</span>
              <!-- Devizás számla: könyv szerinti forintérték MNB-árfolyammal (teljesítés napja) -->
              <div *ngIf="s.brutto_huf != null" class="halvany" style="font-size:.78rem"
                   [title]="'MNB ' + s.arfolyam + ' Ft/' + s.deviza + ' (' + s.arfolyam_datum + ')'">
                = {{ s.brutto_huf | number:'1.0-0' }} Ft
              </div>
              <div *ngIf="s.arfolyam_hiba" class="halvany" style="font-size:.78rem;color:#b45309" [title]="s.arfolyam_hiba">
                nincs árfolyam
              </div>
            </td>
            <td>{{ s.fizmod }}</td>
            <td><ion-button size="small" fill="clear" color="success" (click)="navPdf(s)" [disabled]="!s.van_pdf"><ion-icon slot="icon-only" name="document"></ion-icon></ion-button></td>
            <td><ion-button size="small" fill="clear" *ngIf="!s.konyvelt" (click)="navKonyvel(s)" title="Könyvelés"><ion-icon slot="icon-only" name="arrow-forward-circle"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
